import { createFileRoute } from "@tanstack/react-router";
import { SiteNav } from "@/components/site-nav";
import { SiteFooter } from "@/components/site-footer";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy | MG Content Labs" },
      { name: "description", content: "How MG Content Labs collects, uses, and protects your data." },
      { property: "og:title", content: "Privacy Policy | MG Content Labs" },
      { property: "og:description", content: "How MG Content Labs collects, uses, and protects your data." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { property: "og:url", content: "https://mgcontentlabs.com/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://mgcontentlabs.com/privacy" }],
  }),
  component: Privacy,
});

function Privacy() {
  return (
    <div className="min-h-screen bg-white text-brand-deep">
      <SiteNav />
      <article className="mx-auto max-w-3xl px-6 py-20">
        <span className="text-xs font-bold uppercase tracking-widest text-brand-accent">Legal</span>
        <h1 className="mt-4 font-serif text-5xl">Privacy Policy</h1>
        <p className="mt-2 text-sm text-brand-deep/50">Last updated: July 14, 2026</p>

        <div className="prose mt-12 space-y-8 text-brand-deep/80">
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">1. Introduction</h2>
            <p className="mt-3">
              MG Content Labs ("we", "us") respects your privacy. This policy explains what data we
              collect on our website and services, how we use it, and the choices you have.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">2. Information We Collect</h2>
            <p className="mt-3">
              We collect information you provide directly (name, email, company URL, message) when
              you submit our contact form or subscribe to our newsletter. We also collect basic
              analytics data — page visits, referrer, device type — through privacy-friendly tools.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">3. How We Use Your Data</h2>
            <p className="mt-3">
              We use the information to respond to your inquiries, deliver our services, send
              relevant newsletters (with your consent), and improve our website. We never sell your
              data to third parties.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">4. Cookies</h2>
            <p className="mt-3">
              We use essential cookies to run the site and optional analytics cookies to understand
              how visitors use it. You can disable non-essential cookies in your browser settings.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">5. Data Retention</h2>
            <p className="mt-3">
              We keep contact-form submissions for up to 24 months. Client engagement data is
              retained for the duration of the engagement plus seven years for tax and legal
              compliance.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">6. Your Rights</h2>
            <p className="mt-3">
              Depending on your jurisdiction (GDPR, CCPA, etc.), you may have the right to access,
              correct, or delete your data, and to object to certain processing. Email
              privacy@mgcontentlabs.com to exercise any of these rights.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">7. Contact</h2>
            <p className="mt-3">
              Questions? Reach out to <a className="text-brand-accent" href="mailto:privacy@mgcontentlabs.com">privacy@mgcontentlabs.com</a>.
            </p>
          </section>
        </div>
      </article>
      <SiteFooter />
    </div>
  );
}
